<template>
  <div class="modal_wrapper active">
    <div class="modal_window white_box create_report_modal">
      <button
        class="close_modal close_btn"
        @click="closeModal()"
      >
        <svg
          fill="none"
          height="32"
          viewBox="0 0 32 32"
          width="32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25 7L7 25"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            d="M25 25L7 7"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
        </svg>
      </button>
      <h3 class="heading_h4 font_bold mb_16">
        {{ widgetModal.widget ? 'Edit' : 'Create' }} Citations Widget
      </h3>
      <div :class="'section_wrap '+(settings === 'widget' ? 'open' : '')">
        <div
          class="section_head"
          @click="(settings === 'widget' ? settings = '' : settings = 'widget')"
        >
          <h3 class="section_heading">
            Widget Settings
          </h3>
          <i class="icon arrow_down_icon caret" />
        </div>
        <accordion-transition>
          <div
            v-if="settings === 'widget'"
            class="section_body"
          >
            <custom-input
              v-model="widget.name"
              label="Widget name"
              placeholder="Enter a title for the widget (optional)"
              width="full"
            />

            <custom-multiselect
              v-model="widget.attributes.options.competitors"
              :max="3"
              :options="competitors"
              label="Competitors (max 3)"
              mode="tags"
              width="full"
            />

            <custom-multiselect
              v-model="widget.attributes.options.sections"
              :options="{
                keywords: 'Keywords',
                backlinks: 'Backlinks'
              }"
              label="Sections to include"
              mode="tags"
              width="full"
            />
            <div class="toggles">
              <custom-toggle
                v-model="widget.attributes.options.includeSectionLabels"
                label="Show Section Labels"
                width="half"
              />
            </div>

            <custom-multiselect
              v-if="widget.attributes.options.sections.includes('keywords')"
              v-model="widget.attributes.options.keywordMetrics"
              :options="[
                'Keywords in Position 1',
                'Keywords in Top 3',
                'Keywords on Page 1',
                'Keywords on Page 2',
                'All Keywords',
              ]"
              label="Keyword metrics"
              mode="tags"
              width="full"
            />

            <custom-multiselect
              v-if="widget.attributes.options.sections.includes('backlinks')"
              v-model="widget.attributes.options.backlinkMetrics"
              :options="{
                'Number of Backlinks': 'Number of Backlinks',
                'Number of Linking Domains': 'Number of Linking Domains',
                'Trust Flow': 'Trust Flow',
                'Citation Flow': 'Citation Flow',
                'Link Score': 'Domain Authority',
              }"
              label="Backlink metrics"
              mode="tags"
              width="full"
            />
          </div>
        </accordion-transition>
      </div>

      <div
        v-if="widget.attributes.type === 'table'"
        :class="'section_wrap '+(settings === 'table' ? 'open' : '')"
      >
        <div
          class="section_head"
          @click="(settings === 'table' ? settings = '' : settings = 'table')"
        >
          <h3 class="section_heading">
            Table Settings <small>(optional)</small>
          </h3>
          <i class="icon arrow_down_icon caret" />
        </div>
        <accordion-transition>
          <div
            v-if="settings === 'table'"
            class="section_body"
          >
            <custom-select
              v-model="widget.attributes.tableOptions.align"
              :options="{
                'center' : 'Center',
                'start' : 'Left',
                'end' : 'Right'
              }"
              label="Text Align"
              width="full"
            />

            <custom-color-select
              v-model="widget.attributes.tableOptions.headerColor"
              label="Header color"
              placeholder="Enter a hex value E.g. #ffffff"
              width="half"
            />

            <custom-color-select
              v-model="widget.attributes.tableOptions.headerTextColor"
              label="Header text color"
              placeholder="Enter a hex value E.g. #ffffff"
              width="half"
            />

            <custom-color-select
              v-model="widget.attributes.tableOptions.primaryRowColor"
              label="Primary row color"
              placeholder="Enter a hex value E.g. #ffffff"
              width="half"
            />

            <custom-color-select
              v-model="widget.attributes.tableOptions.primaryRowTextColor"
              label="Primary row text color"
              placeholder="Enter a hex value E.g. #ffffff"
              width="half"
            />

            <custom-color-select
              v-model="widget.attributes.tableOptions.secondaryRowColor"
              label="Secondary row color"
              placeholder="Enter a hex value E.g. #ffffff"
              width="half"
            />

            <custom-color-select
              v-model="widget.attributes.tableOptions.secondaryRowTextColor"
              label="Secondary row text color"
              placeholder="Enter a hex value E.g. #ffffff"
              width="half"
            />
          </div>
        </accordion-transition>
      </div>

      <div class="flex items-center section_modal_footer">
        <button
          class="btn btn_md secondary_btn close_modal ml_auto mr_8"
          @click="closeModal()"
        >
          <span>Cancel</span>
        </button>
        <button
          class="btn btn_md primary_btn"
          @click="save()"
        >
          <span>{{ widgetModal.widget ? 'Update' : 'Create' }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import {mapActions, mapState} from 'vuex';
import CustomInput from '../../global/forms/CustomInput.vue';
import CustomSelect from '../../global/forms/CustomSelect.vue';
import CustomToggle from '../../global/forms/CustomToggle.vue';
import CustomColorSelect from '../../global/forms/CustomColorSelect.vue';
import CustomMultiselect from '../../global/forms/CustomMultiselect.vue';
import AccordionTransition from '../../global/transitions/AccordionTransition.vue';

export default {
  components: {
    CustomInput,
    CustomSelect,
    CustomToggle,
    CustomColorSelect,
    CustomMultiselect,
    AccordionTransition
  },
  emits: ['refresh-widget'],
  data() {
    return {
      datepicker: false,
      settings: 'widget',
      widget: {
        id: `widget-competition-${Date.now()}`,
        name: 'Competition Widget',
        type: 'competition',
        w: 12,
        h: 25,
        frozen: false,
        content: `<div id="widget-citations-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
        attributes: {
          type: 'table',
          options: {
            competitors: [],
            sections: [],
            includeSectionLabels: true,
            keywordMetrics: [
              'Keywords in Position 1',
              'Keywords in Top 3',
              'Keywords on Page 1',
              'Keywords on Page 2',
              'All Keywords',
            ],
            backlinkMetrics: [
              'Number of Backlinks',
              'Number of Linking Domains',
              'Trust Flow',
              'Citation Flow',
              'Link Score'
            ],
            location: null,
            useDatesFrom: 'all_dates',
            dates: {
              dateRange: null,
              compRange: null,
              fromDate: '',
              toDate: '',
              compFromDate: '',
              compToDate: ''
            },
            visibleColumns: ['blank', 'website'],
          },
          tableOptions: {
            align: 'center',
            headerColor: '#F5F5F5',
            headerTextColor: '#4E4E54',
            primaryRowColor: '#FFFFFF',
            primaryRowTextColor: '#4E4E54',
            secondaryRowColor: '#F8F7F5',
            secondaryRowTextColor: '#4E4E54',
          },
        }
      }
    }
  },
  computed: {
    ...mapState(['widgetModal']),
    ...mapState('lookups', ['competitors']),
    ...mapState('report', ['report']),
  },
  beforeMount() {
    if (this.widgetModal.widget) {
      _.merge(this.widget, this.widgetModal.widget);
      this.widget.attributes.options.visibleColumns = this.widgetModal.widget.attributes.options.visibleColumns;
    }
  },
  methods: {
    ...mapActions('pages', ['addWidget', 'updateWidget']),
    ...mapActions('widgetModal', ['closeModal']),
    selectedDateRange(fromDate, toDate) {
      if (fromDate && toDate) {
        let from = moment(fromDate, 'YYYY-MM-DD').format(this.report.date_format);
        let to = moment(toDate, 'YYYY-MM-DD').format(this.report.date_format);
        return from + ' - ' + to;
      }
      return 'Please select dates';
    },
    async save() {
      if (!this.widget.resized && !this.widgetModal.widget) {
        if (this.widget.attributes.type.includes('table') || this.widget.attributes.type.includes('stat-boxes')) this.widget.w = 12;
      }

      let visibleColumns = ['blank', 'website'];
      this.widget.attributes.options.competitors.forEach(id => {
        visibleColumns.push(Number(id));
      });
      this.widget.attributes.options.visibleColumns = visibleColumns;

      // Prep a payload for the vuex action
      const payload = {
        widget: this.widget,
        pageId: this.widgetModal.pageId,
      }

      // Check if we're creating a new widget or editing one
      if (!this.widgetModal.widget) {
        // Save the new pages layout (refreshes store pages)
        await this.addWidget(payload);
      } else {
        // Update the widget
        payload.widget.resized = false;
        await this.updateWidget(payload);
      }

      // Emit to trigger widget refresh, then close the modal
      this.$emit('refresh-widget', {pageId: this.widgetModal.pageId, widget: this.widget});
      this.closeModal();
    }
  },
}
</script>

<style scoped src="../../../../reports/css/modal.css" />
